import React from 'react';
import { motion } from 'framer-motion';
import hero from '../../../assets/hero.png';
import cipa from '../../../assets/cipa3.svg';
import bigCake from '../../../assets/big-cake.png';
import yellowCipa from '../../../assets/yellow-cipa.svg';
import cipaComicsIntro from '../../../assets/cipa-comics-intro.svg';
import cake1 from '../../../assets/cake 1.png';
import cake2 from '../../../assets/cake 2.png';
import cake3 from '../../../assets/cake 3.png';
import cake4 from '../../../assets/cake 4.png';
import cake5 from '../../../assets/cake 5.png';
import '../../../styles/FractionStoryScreen.css';
import useScrollUnlock from '../../../hooks/useScrollUnlock';


const slideUpText = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: 'easeOut' }
  }
};

const staggerCards = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.16,
      delayChildren: 0.25
    }
  }
};

const cardSlideUp = {
  hidden: { opacity: 0, y: 70 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: 'easeOut' }
  }
};

export default function ComicsIntro({ onCheckStateChange }) {
  const rootRef = useScrollUnlock(onCheckStateChange);

  return (
    <div ref={rootRef} className="fraction-story-screen quiz-screen fractions-comics-intro">
      <div className="fraction-story quiz-card">
        <div className="fraction-story-pink-bg">
          <img className="fraction-story-hero" src={hero} alt="" />
          <div className="fraction-story-pink-rectangle">
            <p className="fraction-story-pink-rec-text">
              Сьогодні в мене день народження! Запрошую тебе на святкування 🎉
            </p>
            <p className="fraction-story-go-down">Попереду важлива місія — гортай униз</p>
            <svg className="fraction-story-go-down-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_95_1660" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
                <rect width="40" height="40" fill="#D9D9D9"/>
              </mask>
              <g mask="url(#mask0_95_1660)">
                <path d="M19.8492 25.9062L25.6408 20.1253L24.1825 18.667L20.8963 21.9532V14.0782H18.7863V21.9532L15.5 18.667L14.0417 20.1253L19.8492 25.9062ZM19.8363 35.8337C17.6576 35.8337 15.6067 35.4181 13.6833 34.587C11.76 33.7559 10.081 32.6234 8.64625 31.1895C7.21181 29.7553 6.07875 28.077 5.24708 26.1545C4.41569 24.232 4 22.1816 4 20.0032C4 17.8132 4.41556 15.7548 5.24667 13.8278C6.07778 11.9009 7.21028 10.2248 8.64417 8.79949C10.0783 7.37421 11.7567 6.24574 13.6792 5.41408C15.6017 4.58269 17.6521 4.16699 19.8304 4.16699C22.0204 4.16699 24.0789 4.58255 26.0058 5.41366C27.9328 6.24477 29.6089 7.37269 31.0342 8.79741C32.4594 10.2221 33.5879 11.8975 34.4196 13.8237C35.251 15.7498 35.6667 17.8077 35.6667 19.9974C35.6667 22.176 35.2511 24.227 34.42 26.1503C33.5889 28.0737 32.461 29.7527 31.0363 31.1874C29.6115 32.6219 27.9361 33.7549 26.01 34.5866C24.0839 35.418 22.026 35.8337 19.8363 35.8337ZM19.8333 33.7395C23.6608 33.7395 26.9076 32.4037 29.5738 29.732C32.2396 27.0603 33.5725 23.8164 33.5725 20.0003C33.5725 16.1728 32.2396 12.926 29.5738 10.2599C26.9076 7.59407 23.6608 6.26116 19.8333 6.26116C16.0172 6.26116 12.7733 7.59407 10.1017 10.2599C7.43 12.926 6.09417 16.1728 6.09417 20.0003C6.09417 23.8164 7.43 27.0603 10.1017 29.732C12.7733 32.4037 16.0172 33.7395 19.8333 33.7395Z" fill="#1E1E1E"/>
              </g>
            </svg>

            <div
              className="fraction-story-heroes"
            >
              <div className="fraction-story-hero">
                <img src={cipa} alt="" />
                <p className="thought-bubble left">
                    Допоможеш мені з&nbsp;частуванням?
                </p>
              </div>
            </div>

            <motion.p
              className="fraction-story-pink-rec-text"
              style={{margin: '60px 0'}}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.4 }}
              variants={slideUpText}
            >
              Усе просто: правильно відповідаєш на запитання — додаєш шматочок торта 🍰 Саме ним я пригощу друзів і подруг
            </motion.p>
          </div>

          <div className="fraction-story-white-rectangle" style={{paddingBottom: '80px'}}>
            <img className="fraction-story-big-cake" src={bigCake} alt="" />
            <img className="fraction-cipa-story" src={cipaComicsIntro} alt="" />

            <motion.p
              className="fraction-story-pink-rec-text"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.4 }}
              variants={slideUpText}
            >
              Виконуй завдання правильно — і торт ставитиме крутішим 🍰
            </motion.p>
          </div>

          <div className="fraction-story-blue-rectangle">
            <div className="fraction-story-hero">
              <img src={yellowCipa} alt="" />
              <p className="thought-bubble left">Збери всі частини й відкрий Супергру, щоб створити СУПЕРТОРТ! </p>
            </div>
          </div>

          <div className="fraction-story-pink-rectangle-2" style={{marginTop: '-90px'}}>
            <motion.div
              className="game-map"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={staggerCards}
            >
              <div className="divider-line">
                <div className="icon-top">
                  <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 3C0 1.34315 1.34315 0 3 0H23.1803C25.7906 0 27.1556 3.10297 25.3918 5.02717L20.8582 9.97283C19.8069 11.1198 19.8069 12.8802 20.8582 14.0272L25.3918 18.9728C27.1556 20.897 25.7906 24 23.1803 24H3C1.34315 24 0 22.6569 0 21V3Z" fill="#5B5BD8"/>
                  </svg>
                </div>
                <div className="icon-bottom">
                  <svg width="26" height="48" viewBox="0 0 26 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.3065 17.8734L24.8058 20.1975C26.6949 21.3657 26.0028 22.5765 25.0489 24.0352C19.8858 31.9292 13.6655 39.4167 8.43036 47.2947C7.06438 48.7528 4.73014 47.7926 4.8052 45.8526L9.70178 28.3688L1.1001 26.0202C-1.02327 24.5027 0.393721 23.0884 1.46694 21.5824C6.53801 14.4674 12.0942 7.66724 17.1961 0.571144C18.6433 -0.660056 20.6263 0.219966 20.7417 2.05894L16.3062 17.8734H16.3065Z" fill="#5B5BD8"/>
                  </svg>
                </div>
              </div>

              <motion.div className="level-card left row-1" variants={cardSlideUp}>
                <p className="level-status status-finished">
                  <span className="level-status-text">Завершено</span>
                </p>
                <img src={cake1} alt="cake" />
                <div className="stars">
                  <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1973 1.62816C11.2685 -0.542241 14.3634 -0.542239 15.4345 1.62816L17.1327 5.06894C17.558 5.9308 18.3802 6.52818 19.3314 6.66638L23.1285 7.21814C25.5237 7.56618 26.48 10.5096 24.7469 12.199L21.9992 14.8773C21.311 15.5482 20.9969 16.5148 21.1594 17.462L21.808 21.2438C22.2172 23.6293 19.7133 25.4485 17.571 24.3222L14.1748 22.5367C13.3241 22.0894 12.3078 22.0894 11.457 22.5367L8.0608 24.3222C5.91848 25.4485 3.41465 23.6293 3.82379 21.2438L4.47242 17.462C4.63489 16.5148 4.32083 15.5482 3.63259 14.8773L0.884963 12.199C-0.848203 10.5096 0.108181 7.56618 2.50336 7.21814L6.30048 6.66638C7.25161 6.52818 8.07382 5.9308 8.49918 5.06893L10.1973 1.62816Z" fill="#5B5BD8"/>
                  </svg>
                </div>
              </motion.div>

              <motion.div className="level-card right row-2 level-locked" variants={cardSlideUp}>
                <p className="level-status status-in-progress">
                  <span className="level-status-text">Відкрито</span>
                </p>
                <img src={cake2} alt="cake" />
                <div className="stars">
                  {[...Array(2)].map((_, index) => (
                    <svg key={index} width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.1973 1.62816C11.2685 -0.542241 14.3634 -0.542239 15.4345 1.62816L17.1327 5.06894C17.558 5.9308 18.3802 6.52818 19.3314 6.66638L23.1285 7.21814C25.5237 7.56618 26.48 10.5096 24.7469 12.199L21.9992 14.8773C21.311 15.5482 20.9969 16.5148 21.1594 17.462L21.808 21.2438C22.2172 23.6293 19.7133 25.4485 17.571 24.3222L14.1748 22.5367C13.3241 22.0894 12.3078 22.0894 11.457 22.5367L8.0608 24.3222C5.91848 25.4485 3.41465 23.6293 3.82379 21.2438L4.47242 17.462C4.63489 16.5148 4.32083 15.5482 3.63259 14.8773L0.884963 12.199C-0.848203 10.5096 0.108181 7.56618 2.50336 7.21814L6.30048 6.66638C7.25161 6.52818 8.07382 5.9308 8.49918 5.06893L10.1973 1.62816Z" fill="#5B5BD8"/>
                    </svg>
                  ))}
                </div>
              </motion.div>

              <motion.div className="level-card left row-3 level-locked" variants={cardSlideUp}>
                <p className="level-status status-finished">
                  <span className="level-status-text">Скоро</span>
                </p>
                <img src={cake3} alt="cake" />
                <div className="stars">
                  {[...Array(3)].map((_, index) => (
                    <svg key={index} width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.1973 1.62816C11.2685 -0.542241 14.3634 -0.542239 15.4345 1.62816L17.1327 5.06894C17.558 5.9308 18.3802 6.52818 19.3314 6.66638L23.1285 7.21814C25.5237 7.56618 26.48 10.5096 24.7469 12.199L21.9992 14.8773C21.311 15.5482 20.9969 16.5148 21.1594 17.462L21.808 21.2438C22.2172 23.6293 19.7133 25.4485 17.571 24.3222L14.1748 22.5367C13.3241 22.0894 12.3078 22.0894 11.457 22.5367L8.0608 24.3222C5.91848 25.4485 3.41465 23.6293 3.82379 21.2438L4.47242 17.462C4.63489 16.5148 4.32083 15.5482 3.63259 14.8773L0.884963 12.199C-0.848203 10.5096 0.108181 7.56618 2.50336 7.21814L6.30048 6.66638C7.25161 6.52818 8.07382 5.9308 8.49918 5.06893L10.1973 1.62816Z" fill="#5B5BD8"/>
                    </svg>
                  ))}
                </div>
              </motion.div>

              <motion.div className="level-card right row-4 level-locked" variants={cardSlideUp}>
                <p className="level-status status-finished">
                  <span className="level-status-text">Скоро</span>
                </p>
                <img src={cake4} alt="cake" />
                <div className="stars">
                  {[...Array(4)].map((_, index) => (
                    <svg key={index} width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.1973 1.62816C11.2685 -0.542241 14.3634 -0.542239 15.4345 1.62816L17.1327 5.06894C17.558 5.9308 18.3802 6.52818 19.3314 6.66638L23.1285 7.21814C25.5237 7.56618 26.48 10.5096 24.7469 12.199L21.9992 14.8773C21.311 15.5482 20.9969 16.5148 21.1594 17.462L21.808 21.2438C22.2172 23.6293 19.7133 25.4485 17.571 24.3222L14.1748 22.5367C13.3241 22.0894 12.3078 22.0894 11.457 22.5367L8.0608 24.3222C5.91848 25.4485 3.41465 23.6293 3.82379 21.2438L4.47242 17.462C4.63489 16.5148 4.32083 15.5482 3.63259 14.8773L0.884963 12.199C-0.848203 10.5096 0.108181 7.56618 2.50336 7.21814L6.30048 6.66638C7.25161 6.52818 8.07382 5.9308 8.49918 5.06893L10.1973 1.62816Z" fill="#5B5BD8"/>
                    </svg>
                  ))}
                </div>
              </motion.div>

              <motion.div className="level-card left row-5 level-locked" variants={cardSlideUp}>
                <p className="level-status status-finished">
                  <span className="level-status-text">Скоро</span>
                </p>
                <img src={cake5} alt="cake" />
                <div className="stars">
                  {[...Array(5)].map((_, index) => (
                    <svg key={index} width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.1973 1.62816C11.2685 -0.542241 14.3634 -0.542239 15.4345 1.62816L17.1327 5.06894C17.558 5.9308 18.3802 6.52818 19.3314 6.66638L23.1285 7.21814C25.5237 7.56618 26.48 10.5096 24.7469 12.199L21.9992 14.8773C21.311 15.5482 20.9969 16.5148 21.1594 17.462L21.808 21.2438C22.2172 23.6293 19.7133 25.4485 17.571 24.3222L14.1748 22.5367C13.3241 22.0894 12.3078 22.0894 11.457 22.5367L8.0608 24.3222C5.91848 25.4485 3.41465 23.6293 3.82379 21.2438L4.47242 17.462C4.63489 16.5148 4.32083 15.5482 3.63259 14.8773L0.884963 12.199C-0.848203 10.5096 0.108181 7.56618 2.50336 7.21814L6.30048 6.66638C7.25161 6.52818 8.07382 5.9308 8.49918 5.06893L10.1973 1.62816Z" fill="#5B5BD8"/>
                    </svg>
                  ))}
                </div>
              </motion.div>

              <div className="row-5 right">
                Завдання із зірочкою
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}
